export async function loadExternalBounceInteraction(engine, refresh = true) {
    await engine.addInteractor("externalBounce", async (container) => {
        const { Bouncer } = await import("./Bouncer.js");
        return new Bouncer(container);
    }, refresh);
}
export * from "./Options/Classes/Bounce.js";
export * from "./Options/Interfaces/IBounce.js";
